export default __webpack_public_path__ + "static/media/ost-why-sell-bg_optim.2fe98d96.jpg";